/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { GridView, Griew, Column, Response, Filter } from "react-griew";
import PartyService from "../../service/party-service";
import Pasoonate from "pasoonate";
import CreatePartyWindow from "./CreatePartyWindow";
import EditPartyWindow from "./EditPartyWindow";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";

const partyService = new PartyService();
const griew = new Griew();

await loadDictionary('party-main-page');

function PartyMainPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenCreateWindow, setIsOpenCreateWindow] = useState(false);
  const [isOpenEditWindow, setIsOpenEditWindow] = useState(false);
  const [selectedPartyId, setSelectedPartyId] = useState(null);

  const reloadList = () => { 
    setIsLoading(true);
    griew.filters.add('deleted_at', Column.DATETIME, Filter.IS_EQUAL_TO, null, null);
    griew.refresh(); 
  };

  const handleOpenCreateWindow = () => {
    setIsOpenCreateWindow(true);  
  };

  const handleCloseCreateWindow = () => {
    setIsOpenCreateWindow(false);
    reloadList();
  };

  const handleOpenEditWindow = (partyId) => {
    setSelectedPartyId(partyId);
    setIsOpenEditWindow(true);  
  };

  const handleCloseEditWindow = () => {
    setSelectedPartyId(null);
    setIsOpenEditWindow(false);
    reloadList();
  };

  const handleRemoveParty = (id) => {
    partyService.findOne(id).then(party => {
      if(party && confirm(i18n.t("party-main-page.remove_alert"))) {
        partyService.remove(party).then(result => {
          if(result) {
            reloadList();
          }
        }).catch(error => {
          console.error(error);
        });
      }
    });    
  };

  useEffect(() => {
    prepareGriew(setCount, handleOpenEditWindow, setIsLoading, handleRemoveParty);
    reloadList();
  }, []);

  return (
    <div className="page">
      <div className="page-header bg-body p-3">
        <h4 className="page-title">{i18n.t("party-main-page.page_title")}</h4>
        <div className="header-content"></div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="my-1">{i18n.t("party-main-page.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className="btn btn-sm btn-primary me-2 mb-2" type="button" onClick={handleOpenCreateWindow}>{i18n.t("party-main-page.new_button")}</button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <GridView griew={griew} ></GridView>
        </div>
      </div>
      <CreatePartyWindow isOpenWindow={isOpenCreateWindow} onCloseWindow={handleCloseCreateWindow} />
      <EditPartyWindow isOpenWindow={isOpenEditWindow} onCloseWindow={handleCloseEditWindow} selectedPartyId={selectedPartyId} />
    </div>
  );
}

function prepareGriew(setCount, handleOpenEditWindow, setIsLoading, handleRemoveParty) {
  const list = [
    {
      name: "id",
      caption: "کد",
      schema: "َParty",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "name",
      caption: "نام",
      schema: "Party",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "accounting_number",
      caption: "کد حسابداری",
      schema: "Party",
      type: Column.NUMBER,
      order: 3,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "created_at",
      caption: "تاریخ ایجاد",
      schema: "Party",
      type: Column.DATETIME,
      order: 4,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{createdAt}</span>;
      },
    },
    {
      name: "updated_at",
      caption: "تاریخ ویرایش",
      schema: "Party",
      type: Column.DATETIME,
      order: 5,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const updatedAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{updatedAt}</span>;
      },
    },
    {
      name: "deleted_at",
      caption: "حذف",
      schema: "Party",
      type: Column.DATETIME,
      order: 6,
      sortable: false,
      filterable: false,
      visibility: false,
    },
    {
      name: "",
      caption: "عملیات",
      schema: "",
      type: Column.STRING,
      order: 6,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, party) => { 
        const editButton = party.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light" onClick={() => { handleOpenEditWindow(party.id) }}>{i18n.t("party-main-page.edit_button")}</button>;
        const removeButton = party.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleRemoveParty(party.id) }}>{i18n.t("party-main-page.remove_button")}</button>;

        return (
          <>
          {editButton}          
          {removeButton}
          </>
        );
      }
    }
  ];
  
  const callback = function (promis) {
    promis.then(response => {
      const pagination = response.pagination;
      const data = response.data;

      const res = Response.make({
        data: data,
        pagination: {
          currentPage: pagination?.currentPage ?? 1,
          lastPage: pagination?.lastPage ?? 1,
          perPage: pagination?.perPage ?? 15,
          total: pagination?.total ?? 1,
          from: pagination?.from ?? 1,
          to: pagination?.to ?? 1,
        }
      });

      griew.refresh(res);

      setCount(pagination.total);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
    });
  };
    
  griew.localization.locale = 'fa';
  griew.columns.fromArray(list);
  griew.providers.default = 'function';
  griew.providers.getProvider().options = {
    function: (query) => partyService.gridview(query),
    callback: callback
  };
}

export default PartyMainPage;